import { APICfg } from 'services/api/api'
import { convertEmptyStringToUndefined } from 'services/utils'
import { ProfessionalSpecialType } from 'types/form'
import { APIProfessionalFigure } from '../professional/types/api/response-models'
import { ProductSection, ProductSectionToAPI } from '../types'
import { productSectionParse } from '../utils'

type APIProfessionalSection = ProductSection<APIProfessionalFigure> & {
  specialType: ProfessionalSpecialType
}

export type ProfessionalSection = APIProfessionalSection

export type ProfessionalSectionToApi = ProductSectionToAPI &
  Pick<APIProfessionalSection, 'specialType'>

const apiCfg: APICfg = {
  endpoint: 'professionalsections',
  parse: productSectionParse,
  write: async ({
    specialType,
    ...rest
  }: ProfessionalSection): Promise<ProfessionalSectionToApi> => ({
    ...rest,
    specialType: convertEmptyStringToUndefined(specialType),
  }),
}

export default apiCfg
